import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarEdit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M6.75 3.75h-3a2 2 0 0 0-2 2v3m5-5h6.5m-6.5 0v-2m0 2v1.5m6.5-1.5h3a2 2 0 0 1 2 2v3H1.75m11.5-5v-2m0 2v1.5m-11.5 3.5v7.5a2 2 0 0 0 2 2h5m6.094 1H12.75v-2.094l3.973-3.972a1.48 1.48 0 0 1 2.093 2.093l-3.972 3.973Z"
	})]
});
const ForwardRef = forwardRef(SvgCalendarEdit);
export { ForwardRef as ReactComponent };
